import Vue from 'vue';
import Component from 'vue-class-component';
import getLastTld from 'common/services/utils/getLastTld';

@Component({
  props: {
    categoryColor: {
      type: String,
      required: true,
    },
    categoryID: {
      type: String,
      required: false,
    },
    boxID: {
      type: String,
      required: false,
    },
    activityType: {
      type: String,
      required: true,
      description: 'Type of the activity',
    },
    deliveryForAllCountry: {
      type: Boolean,
      required: false,
      default: false,
      description: 'In case the delivery its free for all',
    },
    hasDeliveryFree: {
      type: Boolean,
      required: true,
      default: false,
      description: 'In case of the delivery activity do not have radius',
    },
    onlineActivityDuration: {
      type: String,
      required: false,
      description: 'Duration of the activity in case is remote',
      default: false,
    },
    participants: {
      type: [String, Number],
      required: true,
      description: 'how many people can participate in the activity',
    },
    validations: {
      type: Number,
      required: true,
      description: 'how many people validated a code with the activity',
    },
    experienceAffected: {
      type: String,
      required: false,
      description: 'Text In case of the activity has been affected',
    },
    showAffectedText: {
      type: Boolean,
      required: false,
      description: 'Flag to show  on site text',
    },
    isAtHome: {
      type: Boolean,
      required: false,
      description: 'Flag to show at home text',
    },
  },
})
export default class MoreInformationComponent extends Vue {
  deliveryText = '';

  /**
   * Emit event to BaseActivityView, it's to show the map.
   */
  showMap() {
    this.$emit('showMap', 'MapContact');
  }

  get isOnline() {
    return this.activityType === 'online';
  }

  get isDelivery() {
    return this.activityType === 'delivery';
  }

  get isOnSite() {
    return this.activityType === 'on-site';
  }

  get showRange() {
    if (this.deliveryForAllCountry) {
      this.deliveryText = 'Gratis a todo el pais';
      return false;
    } else if (!this.hasDeliveryFree) {
      this.deliveryText = 'Take away';
      return false;
    }
    this.deliveryText = 'Sin cargo';
    return true;
  }

  get country() {
    return getLastTld();
  }
}
